import * as z from "zod";
import { UserSessionSchema } from "../core/auth";

export const AttachmentSchema = z.object({
  item_id: z.string().optional(),
  product_id: z.string().uuid(),
  quantity: z.number().int().positive(),
  tier_id: z.string().uuid(),
  price: z.number().positive().multipleOf(0.01),
  title: z.string().min(1),
  part_number: z.string().min(1),
  image: z.string().nullable().optional(),
  weight: z.number(),
  width: z.number().nullable().optional(),
  height: z.number().nullable().optional(),
  length: z.number().nullable().optional(),
  moq: z.number().int().positive(),
  shipping_weight: z.number(),
  shipping_width: z.number().nullable().optional(),
  shipping_height: z.number().nullable().optional(),
  shipping_length: z.number().nullable().optional(),
  decal_number: z.string().optional(),
});

// Base CartItem Schema
export const CartItemSchema = z.object({
  item_id: z.string().optional(),
  product_id: z.string().uuid(),
  tier_id: z.string().uuid(),
  price: z.number().positive().multipleOf(0.01),
  title: z.string().min(1),
  part_number: z.string().min(1),
  image: z.string().nullable().optional(),
  weight: z.number(),
  width: z.number().nullable().optional(),
  height: z.number().nullable().optional(),
  length: z.number().nullable().optional(),
  moq: z.number().int().positive(),
  shipping_weight: z.number(),
  shipping_width: z.number().nullable().optional(),
  shipping_height: z.number().nullable().optional(),
  shipping_length: z.number().nullable().optional(),
  decal_number: z.string().optional(),
  attachments: z.array(AttachmentSchema).nullable().optional(),
});

// Schema for updating cart item quantity
export const UpdateCartItemQuantitySchema = z.object({
  productId: z.string().uuid(),
  tierId: z.string().uuid(),
  quantity: z.number().int().positive(),
  decalNumber: z.string().optional(),
});

// Schema for removing items from cart
export const RemoveFromCartSchema = z.object({
  productId: z.string().uuid(),
  tierId: z.string().uuid(),
  decalNumber: z.string().optional(),
});

// Full Cart Schema
export const CartSchema = z.object({
  id: z.string().uuid(),
  quote_number: z.string().max(255),
  name: z.string().max(255).nullable(),
  user_data: UserSessionSchema,
  cart_items: z.array(CartItemSchema),
  discarded: z.boolean().default(false),
  printed: z.boolean().default(false),
  purchased: z.boolean().default(false),
  notes: z.string().optional().nullable(),
  created: z.date().optional(),
  updated: z.date().optional(),
  needsMigration: z.boolean().optional(),
});

// Schema for creating a new cart
export const CreateCartSchema = CartSchema.omit({
  id: true,
  created: true,
  updated: true,
  printed: true,
}).extend({
  name: z.string().max(255).nullable().optional(),
  notes: z.string().nullable().optional(),
});

// Schema for updating a cart
export const UpdateCartSchema = CartSchema.partial().extend({
  id: z.string().uuid(),
});
